/* Eraya price-test bridge for the UNO theme.
   The SDK only scans at init; this re-applies test prices after the theme re-renders them. */
(function () {
  'use strict';
  function getManager() {
    try {
      var E = window.Eraya;
      if (E && E.sdk && typeof E.sdk.getPriceTestManager === 'function') return E.sdk.getPriceTestManager();
    } catch (_) {}
    return null;
  }

  function variantFromUrl(url) {
    var m = /[?&]variant=(\d+)/.exec(url || '');
    return m ? m[1] : null;
  }

  function reapply(root, variantId) {
    var productId = root && root.getAttribute('data-product-id');
    if (!productId) return;
    if (variantId) root.setAttribute('data-variant-id', String(variantId));
    var mgr = getManager();
    if (mgr && typeof mgr.updatePricesForProduct === 'function') {
      try { mgr.updatePricesForProduct(productId, variantId ? String(variantId) : undefined); } catch (_) {}
    }
  }

  function testPrice(root) {
    var mgr = getManager(), vid = root.dataset.currentVariant;
    return vid && mgr && typeof mgr.getPriceByVariantId === 'function' ? mgr.getPriceByVariantId(String(vid)) : null;
  }

  // ATC <product-bundle-price> also re-renders WITHOUT a priceChange (connectedCallback when the
  // sticky panel moves it, quantity/bundle changes) via resolveMainUnitPrice() → currentUnitPrice.
  // Make that property report the test price; the theme's own writes still land in `raw`.
  function hookUnitPrice(root) {
    if (root._erayaUnitHooked) return;
    root._erayaUnitHooked = true;
    var raw = root.currentUnitPrice;
    Object.defineProperty(root, 'currentUnitPrice', {
      configurable: true,
      get: function () { var t = raw != null ? testPrice(root) : null; return t != null ? t : raw; },
      set: function (v) { raw = v; }
    });
  }
  document.querySelectorAll('product-main').forEach(hookUnitPrice);

  // 1. PDP: <product-price>.renderPriceData() rewrites .final/.compare to the ORIGINAL price on
  //    connect, variantChange, quantityChange and sellingPlanChange, then dispatches a
  //    non-bubbling `priceChange` on <product-main>. Capture phase reaches it after the write.
  document.addEventListener('priceChange', function (e) {
    var root = e.target;
    if (!root || root.tagName !== 'PRODUCT-MAIN') return;
    hookUnitPrice(root);
    // ATC <product-bundle-price> renders detail.unitPrice × qty; feed it the test price (cents).
    var d = e.detail, vid = root.dataset.currentVariant;
    var test = d && d.unitPrice != null ? testPrice(root) : null;
    if (test != null) {
      if (d.totalPrice != null && d.unitPrice) d.totalPrice = d.totalPrice / d.unitPrice * test;
      d.unitPrice = test;
    }
    reapply(root, vid);
  }, true);

  // 2. Cards: component_product_card.js onSwatchChange() writes the swatch's data-price-final
  //    (listener on the input, so it runs before this document-level one).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[data-variant-url]')) return;
    reapply(input.closest('product-card[data-product-id]'), variantFromUrl(input.getAttribute('data-variant-url')));
  });

  // 3. AJAX-injected cards (recommendations, predictive search, quick view, drawer).
  //    childList only: attribute writes above must not retrigger this.
  var t = null;
  function rescan() {
    var mgr = getManager();
    if (mgr && typeof mgr.updatePricesOnCurrentPage === 'function') {
      try { mgr.updatePricesOnCurrentPage(); } catch (_) {}
    }
  }
  function schedule() { clearTimeout(t); t = setTimeout(rescan, 150); }
  function hasPid(n) {
    return n.nodeType === 1 && (n.hasAttribute('data-product-id') || n.querySelector('[data-product-id]') !== null);
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) if (hasPid(a[j])) { schedule(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // product-price may connect (and render original prices) after the SDK's init scan.
  window.addEventListener('load', schedule);

  // The PDP's first priceChange fires before the SDK loads, so the ATC keeps the original price.
  // Replay it once the SDK is ready; handler 1 swaps in the test price.
  function replayPriceChange() {
    document.querySelectorAll('product-main').forEach(function (root) {
      var unit = root.currentUnitPrice;
      if (unit == null) return;
      root.dispatchEvent(new CustomEvent('priceChange', {
        detail: { unitPrice: unit, totalPrice: root.currentTotalPrice != null ? root.currentTotalPrice : unit }
      }));
    });
  }
  // The SDK dispatches eraya:ready BEFORE it assigns window.Eraya.sdk, so defer one tick.
  if (window.ErayaReady) replayPriceChange();
  window.addEventListener('eraya:ready', function () { setTimeout(replayPriceChange, 0); });
})();
